import { getCurDate } from "../utils/DateTimeUtils"
import ApiHelper from "./ApiHelper"
import { baseURL } from "./axiosClient"

export const AdminApi = {
    FetchUsers: async (payload) => {

        const url = encodeURI(`/admin/getChildrenUsers`)
        const result = await ApiHelper.get(url)
        return result.data
    },
    FetchDmTinh: async () => {
        const url = encodeURI(`/danhmuc/dmtinh?mienCuPhapId=0`)
        const result = await ApiHelper.get(url)
        return result.data
    },
    PostCreateUser: async (payload) => {
        const url = encodeURI(`/admin/postCreateUser`)
        const result = await ApiHelper.post(url, payload)
        return result.data
    },
    PostUpdateUser: async (payload) => {
        const url = encodeURI(`/admin/postEditUser`)
        const result = await ApiHelper.post(url, payload)
        return result.data
    },
    PostThanhToan: async (payload) => {
        const url = encodeURI(`/admin/postThanhToan`)
        const result = await ApiHelper.post(url, payload)
        return result.data
    },
    ChangePassword: async (payload) => {
        //{oldPassword:string,newPassword:string}
        const url = encodeURI(`/admin/changePassword`)
        const result = await ApiHelper.post(url, payload)
        return result.data
    },

    GetKQTTDP: async (payload) => {
        //{oldPassword:string,newPassword:string}
        const urlmb = "https://xosodaiphat.com/xsmb-truc-tiep.html"
        const urlmt = "https://xosodaiphat.com/xsmt-truc-tiep.html"
        const urlmn = "https://xosodaiphat.com/xsmn-truc-tiep.html"
        const url = encodeURI(`/bot/downLoadKetQua?urlmb=${urlmb}&urlmt=${urlmt}&urlmn=${urlmn}`)
        const result = await ApiHelper.get(url, payload)
        return result.data
    },
    GetKQTTXSHN: async (payload) => {
        //{oldPassword:string,newPassword:string}

        const ngay = getCurDate()
        const url = encodeURI(`/bot/downLoadKetQuaXSHNTrucTiep?ngay=${ngay}`)
        const result = await ApiHelper.get(url, payload)
        return result.data
    },
    GetKQXSHN: async (payload) => {
        //{oldPassword:string,newPassword:string}

        const ngay = getCurDate()
        const url = encodeURI(`/bot/downLoadKetQuaXSHN?ngay=${ngay}`)
        const result = await ApiHelper.get(url, payload)
        return result.data
    },
    GetKQMinhNgoc: async (payload) => {
        //{oldPassword:string,newPassword:string}

        const ngay = getCurDate()
        const url = encodeURI(`/ketqua/downLoadKetQuaMinhNgoc?ngay=${ngay}`)
        const result = await ApiHelper.get(url, payload)
        return result.data
    },
    GetKQTTXSKTVN: async (payload) => {
        //{oldPassword:string,newPassword:string}

        const ngay = getCurDate()
        const url = encodeURI(`/ketqua/getKetQuaTrucTiepXSKTVN?ngay=${ngay}`)
        const result = await ApiHelper.get(url, payload)
        return result.data
    }, GetDirectChilren: async (payload) => {
        //{oldPassword:string,newPassword:string}

        const { userId } = payload
        const url = encodeURI(`/admin/getDirectChildren?userId=${userId}`)
        const result = await ApiHelper.get(url, payload)
        return result.data
    }, GetXSMN_MB: async (payload) => {
        /*xsmn.mobi lấy kqxs miền bắc*/
        const ngay = getCurDate()
        const url = encodeURI(`/ketqua/LayKetQuaXsMnMoBiMienBacRest?url=MB`)
        const result = await ApiHelper.get(url, payload)
        return result.data
    }, GetXSMN_MT: async (payload) => {
        /*xsmn.mobi lấy kqxs miền trung*/
        const ngay = getCurDate()
        const url = encodeURI(`/ketqua/LayKetQuaXsMnMoBiRest?url=MT`)
        const result = await ApiHelper.get(url, payload)
        return result.data
    }, GetXSMN_MN: async (payload) => {
        /*xsmn.mobi lấy kqxs miền nam*/
        const ngay = getCurDate()
        const url = encodeURI(`/ketqua/LayKetQuaXsMnMoBiRest?url=MN`)
        const result = await ApiHelper.get(url, payload)
        return result.data
    }, GetTestMessages: async (payload) => {
        /*xsmn.mobi lấy kqxs miền nam*/
        const {thu, tinhId, fromDate, toDate, lenFrom, lenTo, limit,mien} = payload
       
        const url = encodeURI(`/admin/getTestMessage?thu=${thu}&tinhId=${tinhId}&fromDate=${fromDate}&toDate=${toDate}&lenFrom=${lenFrom}&lenTo=${lenTo}&limit=${limit}&mien=${mien}`)
        const result = await ApiHelper.get(url, payload)
        return result.data
    }, GetParsedMessages: async (payload) => {
        /*xsmn.mobi lấy kqxs miền nam*/
        const {contactId, fromDate, toDate, lenFrom, lenTo, limit,mien} = payload
       
        const url = encodeURI(`/admin/getParsedMessageByUserId?contactId=${contactId}&fromDate=${fromDate}&toDate=${toDate}&lenFrom=${lenFrom}&lenTo=${lenTo}&limit=${limit}&mien=${mien}`)
        const result = await ApiHelper.get(url, payload)
        return result.data
    }
}